import { Link } from 'react-router-dom';
import Accordion from '../components/Accordion';
import { Check } from 'lucide-react';
export default function Home() {
  return (
    <>
      {/* Hero */}
      <section id="home" className="py-10 lg:py-20 bg-[#e4eef9]">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col-reverse lg:flex-row items-center gap-10 lg:gap-16">
            <div className="lg:w-1/2">
              <h1 className="text-5xl lg:text-7xl font-bold text-[#242D60] leading-none">
                Votre santé, notre priorité absolue
              </h1>
              <p className="mt-4 text-lg text-[#5a3d29]">
                Santé Flex vous permet d'accédez à une couverture santé fiable, flexible et immédiatement disponible, conçue pour protéger ce qui compte le plus pour vous.
              </p>
              {/* <h1 className="text-4xl lg:text-5xl font-bold text-[#242D60] leading-none">
                Santé Flex, la solution d'assurance santé simple, accessible et pensée pour votre bien-être et celui de votre famille.
              </h1>
              <p className="mt-4 text-lg text-[#5a3d29]">
                Offrez-vous la tranquillité d'esprit avec une couverture complète incluant :
                Soins ambulatoires | Hospitalisation | Pharmacie | Soins dentaires | Optique | Maternité
              </p> */}
              <div className="mt-6">
                <Link
                  to="/step-0"
                  className="rounded-md bg-primary px-6 py-4 text-base font-medium text-secondary transition hover:bg-primary-dark hover:text-light"
                >
                  Je souscris maintenant
                </Link>
              </div>
            </div>
            <div className="lg:w-1/2 relative">
              <img
                src="assets/images/img1.png"
                alt="Sante Flex"
                className="mx-auto w-full max-w-xs lg:max-w-md rounded-xl bg-white p-2 transform rotate-2"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Key Figures */}
      <section id="key-figures" className="py-16 text-center">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* <h2 className="text-5xl font-bold text-[#242D60]">Obtenez la protection adéquate pour continuer à aller de l'avant.</h2>
          <p className="mx-auto mt-4 max-w-3xl text-lg">
            Nos performances reflètent notre engagement : accompagner, protéger et satisfaire durablement chaque assuré. Découvrez en un coup d’œil l’impact réel de notre expertise.
          </p> */}
          <h2 className="text-5xl font-bold text-[#242D60]">Santé Flex, la solution d'assurance santé simple, accessible et pensée pour votre bien-être et celui de votre famille.</h2>
          <p className="mx-auto mt-4 max-w-3xl text-lg">
            Offrez-vous la tranquillité d'esprit avec une couverture complète incluant : <br />
            Soins ambulatoires | Hospitalisation | Pharmacie | Soins dentaires | Optique | Maternité.
          </p>
          <div className="mx-auto mt-10 max-w-5xl rounded-2xl p-8 text-white">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-6 text-center">
              <div>
                <div className="text-lg uppercase tracking-wide text-secondary font-bold pb-1">Assurés</div>
                <div className="text-[50px] font-extrabold text-[#242D60]">+ 12 000</div>
                <div className="text-sm text-black">assurés protégés chaque année</div>
              </div>
              <div className="hidden sm:block w-px h-16 bg-secondary "></div>
              <div>
                <div className="text-lg uppercase tracking-wide text-secondary font-bold pb-1">Clients</div>
                <div className="text-[50px] font-extrabold text-[#242D60]">98 %</div>
                <div className="text-sm text-black">de nos clients renouvellent leur contrat</div>
              </div>
              <div className="hidden sm:block w-px h-16 bg-secondary "></div>
              <div>
                <div className="text-lg uppercase tracking-wide text-secondary font-bold pb-1">Support</div>
                <div className="text-[50px] font-extrabold text-[#242D60]">24/7</div>
                <div className="text-sm text-black">Des partenariats solides avec les meilleurs établissements de santé</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section id="advantages" className="border-gray-200 py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-10 lg:gap-16">
            <div className="lg:w-1/2">
              <img
                src="assets/images/img2.jpeg"
                alt="About"
                className="mx-auto w-full max-w-xs lg:max-w-md rounded-xl bg-gray-100 p-2 transform -rotate-1 shadow"
                loading="lazy"
              />
            </div>
            <div className="lg:w-1/2">
              <h2 className="text-[50px] leading-snug font-extrabold text-[#242D60]">
                Une protection pensée pour vous, pas pour compliquer votre vie
              </h2>
              <p className="mt-4">
                Avec notre assurance santé, vous bénéficiez d&apos;un accompagnement complet, d’une prise en charge rapide et de garanties réellement utiles au quotidien. Nous simplifions tout, pour que vous puissiez vous concentrer sur votre bien-être.
              </p>
              <ul className="mt-6 space-y-3">
                {[
                  "Remboursements express : vos frais médicaux pris en charge sans attente inutile.",
                  "Assistance santé 24/7 : un soutien immédiat en cas d’urgence, où que vous soyez.",
                  "Réseau de soins élargi : des cliniques, médecins et hôpitaux partenaires partout dans le pays.",
                  "Formules adaptées à votre budget : des garanties flexibles, sans dépenses excessives."
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <span className="text-secondary mt-1 font-bold"><Check size={24}/></span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section id="how" className="py-16 bg-gray-50 text-center">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h2 className="text-5xl font-bold">Souscrire, c&apos;est simple comme 1-2-3</h2>
          <p className="mx-auto mt-4 max-w-3xl">
            Nous avons conçu un parcours rapide, sans paperasse et 100 % digital pour vous permettre d’obtenir une couverture santé en quelques minutes.
          </p>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { num: "01", title: "Remplissez\nvotre formulaire", desc: "Indiquez vos informations essentielles afin que nous puissions comprendre vos besoins et vous proposer une couverture réellement adaptée." },
              { num: "02", title: "Recevez votre\ndevi personnalisé", desc: "Nous vous envoyons une proposition claire, transparente et ajustée à votre profil. Pas de surprises, pas de frais cachés." },
              { num: "03", title: "Souscrivez et soyez immédiatement protégé", desc: "Finalisez votre adhésion en ligne et bénéficiez instantanément de votre couverture santé et de tous vos avantages." }
            ].map((step, i) => (
              <div key={i} className="text-left p-6">
                <div className="text-[50px] font-bold text-gray-800 border-secondary border-b-2 inline-block">{step.num}</div>
                <h3 className="my-4 text-[20px] font-bold text-[#242D60] whitespace-pre-line">{step.title}</h3>
                <p className="text-sm">{step.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-10">
            <Link
              to="/step-0"
              className="rounded-md bg-primary px-8 py-4 text-base font-medium text-secondary transition hover:bg-primary-dark hover:text-light"
            >
              Souscrire maintenant
            </Link>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-16 text-center">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h2 className="text-5xl font-bold">Vos questions, nos réponses</h2>
          <p className="mx-auto mt-4 max-w-3xl">
            Parce qu&apos;une bonne décision commence par une information claire, voici les réponses aux questions que nos assurés posent le plus souvent.
          </p>
          <div className="mx-auto mt-10 max-w-4xl">
            <Accordion />
          </div>
          <div className="mt-10">
            <Link
              to="/step-0"
              className="rounded-md bg-primary px-6 py-4 text-base font-medium text-secondary transition hover:bg-primary-dark hover:text-light"
            >
              Souscrire maintenant
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-16">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="rounded-2xl bg-secondary px-10 text-center py-16 shadow-lg">
            <h2 className="text-[50px] font-extrabold text-white px-8">Protégez ce qui compte le plus, dès aujourd&lsquo;hui</h2>
            <p className="mt-4 text-white">
              Votre santé et celle de votre famille mérite une couverture fiable, simple et accessible. Avec nos formules flexibles et notre assistance 24/7, vous bénéficiez d’une protection immédiate et d’un accompagnement constant.
            </p>
            <div className="mt-12">
              <Link
                to="/step-0"
                className="rounded-md bg-white border border-secondary px-6 py-4 text-base font-medium text-secondary transition hover:border-primary hover:bg-primary-dark hover:text-light"
              >
                Je souscris maintenant
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}